// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"3869f0849059836f","5763":"6a354d1823be2cf0","7222":"dc7a61e45e34a4e4","7937":"2d4d05638b02c4fe"}[chunkId] + ".js";
};